import React, { useEffect, useState } from 'react';
import Menu from '../Menu/Menu';
import MenuItem from '../Menu/MenuItem';
import { Icon } from '../Icon';
import styles from './CardMenu.module.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const CardMenu = ({
  customStyles,
  menuRef,
  listMode,
  item,
  itemIndex,
  handleOpenPreferenses,
  handleOpenApprovalsFeedback,
  handleOpenReviewMode,
  toggleShowMenu,
  shareFolder,
  renameItem,
  handleCopyClick,
  moveItem,
  shareItem,
  removeFromReview,
  duplicateItem,
  downloadItem,
  archiveItem,
  deleteVideo,
  deleteFolder,
  unarchiveItem,
  submitForReview,
  approveVideo,
  declineVideo,
  revokeVideo,
  trimItem,
  addTransition,
  uploadItem,
  addItem,
  recordItem,
  addEmptyItem,
  inviteUser,
  topOffset = true,
  rightOffset = false,
  handleRequestRevise,
  classNames,
}) => {

  const { t } = useTranslation();

  const [openedMenuPosition, setOpenedMenuPosition] = useState({});
  const [loading, setLoading] = useState(true);
  const mediaMatch = window.matchMedia('(max-width: 900px)');

  useEffect(() => {
    if (menuRef.current) {
      const BOTTOM_MENU_OFFSET = 120;
      const LEFT_MENU_OFFSET = 70;
      const customStylesTop = customStyles?.hasOwnProperty('top') ? customStyles?.top : 0;
      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const { offsetHeight, offsetTop, offsetWidth, offsetLeft, offsetParent } = menuRef.current;
      const menuRect = menuRef.current.getBoundingClientRect();
      const positionY = menuRect.y - offsetTop + BOTTOM_MENU_OFFSET + customStylesTop;
      let top = '';
      if (topOffset) {
        if (positionY + offsetHeight > height) {
          // If menu will cross top and bottom boundaries - show it in the middle
          if (menuRect.y - offsetTop - offsetHeight < 0) {
            if (Math.abs(customStylesTop)) {
              let topPosition = customStylesTop - offsetHeight / 2;
              if (topPosition + offsetHeight >= height) {
                topPosition -= topPosition + offsetHeight - height + 30;
              }
              top = topPosition;
            } else {
              top = '-50%';
            }
          } else {
            // If only bottom boundary is crossed - show menu on the top of three dots button
            top = customStylesTop - offsetHeight - 32;
          }
        } else if (positionY < 0) {
          top = customStylesTop + positionY;
        } else {
          top = customStyles?.top;
        }
      } else {
        top = customStyles?.top;
      }
      let left = '';
      if (customStyles?.hasOwnProperty('left')) {
        left = customStyles.left;
      }
      if (rightOffset) {
        const containerRect = offsetParent.offsetParent.getBoundingClientRect();
        const width = containerRect.x + containerRect.width;
        if (customStyles?.hasOwnProperty('left')) {
          if (left + offsetWidth > width) {
            left = width - offsetWidth - LEFT_MENU_OFFSET;
          }
        } else {
          const positionX = menuRect.x - offsetLeft + LEFT_MENU_OFFSET;
          left = positionX + offsetWidth > width ? '0px' : '';
        }
      }

      const styles = { top, left };
      if (customStyles?.hasOwnProperty('position')) {
        styles.position = customStyles.position;
      }

      if (customStyles?.hasOwnProperty('transform')) {
        styles.transform = customStyles.transform;
      }

      setOpenedMenuPosition(styles);
      setLoading(false);
    }
  }, [menuRef]);

  return (
    <Menu
      className={cx(classNames)}
      ref={menuRef}
      listMode={listMode}
      customStyles={{ ...openedMenuPosition, opacity: loading ? '0' : '1' }}
    >
      {submitForReview && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            submitForReview();
          }}
        >
          <Icon src="reviewLarge" /> <span>{t('general.video_action_button.submit_for_review')}</span>
        </MenuItem>
      )}
      {handleOpenApprovalsFeedback && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            handleOpenApprovalsFeedback();
          }}
        >
          <Icon src="chatReview" /> <span>{t('approvals.main')}</span>
        </MenuItem>
      )}
      {handleOpenReviewMode && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            handleOpenReviewMode();
          }}
        >
          <Icon src="reviewLarge" /> <span>{t('general.video_action_button.review')}</span>
        </MenuItem>
      )}
      {handleOpenPreferenses && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            handleOpenPreferenses(item.id);
          }}
        >
          <Icon src="preference" /> <span>{t('my_video.tools.video_viewer_settings')}</span>
        </MenuItem>
      )}
      {shareFolder && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            shareFolder(item);
          }}
        >
          <Icon tabIndex={-1} src="shareFolder" /> <span>{t('general.folder_action_button.share_folder')}</span>
        </MenuItem>
      )}
      {moveItem && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            moveItem(item.id, item.name, itemIndex, item.folder, item.author, item.isProtected);
          }}
        >
          <Icon src="move" /> <span>{t('general.video_action_button.move')}</span>
        </MenuItem>
      )}
      {handleRequestRevise && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            handleRequestRevise();
          }}
        >
          <Icon src="revise" /> <span>{t('general.video_action_button.request_revise')}</span>
        </MenuItem>
      )}
      {renameItem && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            renameItem(item.id);
          }}
        >
          <Icon src="rename" /> <span>{t('general.video_action_button.rename')}</span>
        </MenuItem>
      )}
      {trimItem && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            trimItem(item.id, itemIndex);
          }}
        >
          <Icon src="trim" /> <span>{t('my_video.tools.trim')}</span>
        </MenuItem>
      )}
      {handleCopyClick && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            handleCopyClick(item.id);
          }}
        >
          <Icon src="copy_link" /> <span>{t('general.video_action_button.copy_link')}</span>
        </MenuItem>
      )}
      {shareItem && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            shareItem(item.id);
          }}
        >
          <Icon src="share" /> <span>{t('general.video_action_button.share')}</span>
        </MenuItem>
      )}
      {removeFromReview && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            removeFromReview(item.id, item.name);
          }}
        >
          <Icon src="revoke" /> <span>{t('general.video_action_button.remove_from_review')}</span>
        </MenuItem>
      )}
      {duplicateItem && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            duplicateItem(item.id, item.name);
          }}
        >
          <Icon src="duplicate" /> <span>{t('general.video_action_button.duplicate')} </span>
        </MenuItem>
      )}
      {downloadItem?.action && (
        <MenuItem
          disabled={downloadItem.disabled}
          onClick={() => {
            toggleShowMenu();
            item?.video && downloadItem.action(item.id);
          }}
          onHover={downloadItem.message}
          messageClassName={styles.notification}
        >
          <Icon src="download" /> <span>{t('general.video_action_button.download')}</span>
        </MenuItem>
      )}
      {archiveItem && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            archiveItem(item.id, item.name);
          }}
        >
          <Icon src="archive" /> <span>{t('general.video_action_button.archive')}</span>
        </MenuItem>
      )}
      {unarchiveItem && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            unarchiveItem(item.id, itemIndex, item.name);
          }}
        >
          <Icon src="unarchive" /> <span>{t('general.video_action_button.unarchive')} </span>
        </MenuItem>
      )}
      {deleteVideo && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            deleteVideo(item.id, itemIndex, item.name, item.author);
          }}
        >
          <Icon src="bin" /> <span>{t('general.video_action_button.delete')}</span>
        </MenuItem>
      )}
      {deleteFolder && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            deleteFolder(item.id, itemIndex, item.name, item?.owner, item?.users, !!item?.editingEnabled);
          }}
        >
          <Icon src="bin" /> <span>{t('general.video_action_button.delete')}</span>
        </MenuItem>
      )}
      {approveVideo && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            approveVideo(item.id, itemIndex, item.name, item.author);
          }}
        >
          <Icon src="approve" /> <span>{t('general.video_action_button.approve')}</span>
        </MenuItem>
      )}
      {declineVideo && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            declineVideo(item.id, itemIndex, item.name, item.author);
          }}
        >
          <Icon src="decline" /> <span>{t('general.video_action_button.decline')}</span>
        </MenuItem>
      )}
      {revokeVideo && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            revokeVideo(item.id, itemIndex, item.name, item.author);
          }}
        >
          <Icon src="revoke" /> <span>{t('general.video_action_button.revoke')}</span>
        </MenuItem>
      )}
      {addTransition && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            addTransition(itemIndex, item.position);
          }}
        >
          <span>{t('general.video_action_button.transition')}</span>
        </MenuItem>
      )}
      {recordItem?.action && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            recordItem.action({ index: itemIndex, before: item.position });
          }}
          disabled={recordItem.disabled}
          onHover={recordItem.message}
        >
          <span>{t('general.video_action_button.record_or_upload')}</span>
        </MenuItem>
      )}
      {uploadItem?.action && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            uploadItem.action(itemIndex, item.position);
          }}
          disabled={uploadItem.disabled}
          onHover={uploadItem.message}
        >
          {uploadItem?.icon && <Icon src={uploadItem.icon} />}
          <span>{t('dashboard.new_video.upload_video.button')}</span>
        </MenuItem>
      )}
      {addItem && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            addItem(itemIndex, item.position);
          }}
        >
          <span>{t('general.video_action_button.video_clip')}</span>
        </MenuItem>
      )}
      {inviteUser && (
        <MenuItem
          onClick={() => {
            toggleShowMenu();
            inviteUser(itemIndex, item.position);
          }}
        >
          <Icon src="shareFolder" /> <span>{t('storyboard.editor.invite')}</span>
        </MenuItem>
      )}
      {addEmptyItem && <hr className={styles.divider} style={{ marginTop: '8px', marginBottom: '8px' }} />}
      {addEmptyItem && (
        <MenuItem
          className={cx(styles.addItem)}
          onClick={() => {
            toggleShowMenu();
            addEmptyItem(itemIndex, item.position);
          }}
        >
          <span>{t('general.video_action_button.empty_video_clip')}</span>
        </MenuItem>
      )}
    </Menu>
  );
};

export default CardMenu;
